"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withDefaultHandler;

/**
 * Creates a cancelable event handler that will run unless the provided
 * handler calls `e.preventDefault()`.
 *
 * @param {Function} handler The original event handle supplied to the component
 * @param {Function} defaultHandler A handler to run unless `e.preventDefault()` was called.
 * @return {Function}
 */
function withDefaultHandler(handler, defaultHandler) {
  return function (e) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (handler) {
      handler.apply(void 0, [e].concat(args));
    }

    if (!e.defaultPrevented) {
      defaultHandler.apply(void 0, [e].concat(args));
    }
  };
}
